import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({ 

    state: {
      login: true, // true => Activa la página de login, false => Entramos directamente  
      admin: true, // Determina si es administrador o no    
      fondoDialog: 'fondoDialogClinica', 
      showQueueCalipso: false,        
      fondoTitle: 'widget-title-clinica fadeIn',
      // URL_API_CALIPSO: 'http://localhost:3000',
      URL_API_CALIPSO: 'https://calipso3407.aunnaitapp.es:3000',
      COLAS: [ 
        { name: 'UGC_BURGOS', name_print: 'UGC_BURGOS', ddi: '947740001', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'UGC_VALLADOLID', name_print: 'UGC_VALLADOLID', ddi: '983910299', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'UGC_NORTE', name_print: 'UGC_NORTE', ddi: '945670001', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        //{ name: 'UGC_MADRID', name_print: 'UGC_MADRID', ddi: null, calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        //{ name: 'A+V_NORESTE', name_print: 'A+V_NORESTE', ddi: '931318699', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'MASMOVIL', name_print: 'MASMOVIL', ddi: '946780800', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'Devoluciones', name_print: 'Devoluciones', ddi: '911095206', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'JAZZTEL', name_print: 'JAZZTEL', ddi: '947740002', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'NMME', name_print: 'NMME', ddi: '911095204', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'CT', name_print: 'CT', ddi: '911095205', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: '1002', name_print: '1002', ddi: '911095202', calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
        { name: 'Contingencia', name_print: 'Centro técnico', ddi: null, calls: 0, strategy: '', extensiones: [], agentes: [], llamadas: [], info: '' },
      ]
    },

    actions: { 
   
    },
 
    mutations: {
      loginOK() {
        this.state.login = false
      },
      loginKO() {        
        this.state.login = true       
      },
      isAdmin() {
        this.state.admin = true
      },      
    },

    getters: {     
      getTheme: state => {
        return state.fondoDialog
      },
      getFondoTitle: state => {
        return state.fondoTitle
      }             
    }
  })
}


// WEBPACK FOOTER //
// ./src/store/index.js